import { cn } from '@/lib/utils';
import NoItems from '@/components/ui/NoItems.tsx';
import { ChangeSummaryGroupVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ChangeSummaryTableHeader from './ChangeSummaryTableHeader.tsx';
import ChangeSummaryPersonRow from './ChangeSummaryPersonRow.tsx';
import ChangeSummaryItemRow from './ChangeSummaryItemRow.tsx';
import {
  ChangeSummaryTableVariant,
  summaryGutterClass,
} from './changeSummaryTableLayout.ts';

interface ChangeSummaryTableProps extends React.HTMLAttributes<HTMLDivElement> {
  groups: ChangeSummaryGroupVm[];
  /** `client` zwęża kolumny i pokazuje rolę w wersji dla zapisującego. */
  variant?: ChangeSummaryTableVariant;
}

/** Tabela zmian paczki: kto, co, wartość przed i po, wpływ na kwotę. */
const ChangeSummaryTable = ({
  groups,
  variant = 'operator',
  className,
  ...props
}: ChangeSummaryTableProps) => {
  if (groups.length === 0) {
    return (
      <div
        className={cn(
          '@container',
          summaryGutterClass(variant),
          'py-6',
          className,
        )}
        {...props}
      >
        <NoItems
          title="Brak zmian w paczce"
          description="Szkic nie niesie jeszcze żadnej pozycji — wróć do edycji i zmień coś w rezerwacji."
        />
      </div>
    );
  }

  return (
    <div
      role="table"
      aria-label="Zmiany w paczce"
      className={cn('@container', className)}
      {...props}
    >
      <ChangeSummaryTableHeader variant={variant} />

      {groups.map((group) => (
        <div role="rowgroup" key={group.id}>
          <ChangeSummaryPersonRow group={group} variant={variant} />

          {group.items.map((item) => (
            <ChangeSummaryItemRow key={item.id} item={item} variant={variant} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ChangeSummaryTable;
